import { useState } from 'react';
import NotificationActionLayout, { NotificationActionLayoutType } from "../../components/NotificationActionLayout/NotificationActionLayout";
import { handleRequest } from "../../infra/utils";
import { getApproveAmendmentContent } from "./NotificationAction.utils";
import { useStoreActions } from "../../store/store-context";
import { jsx as _jsx } from "react/jsx-runtime";
const ApproveAmendmentAction = _ref => {
  let {
    token,
    vendorName
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [approveResultContent, setApproveResultContent] = useState();
  const [loading, setLoading] = useState(false);
  async function sendApproveAmendmentsAction() {
    setLoading(true);
    const amendmentApproveResult = await handleRequest(api.relationship.approveAmendmentFromEmail({
      approvalToken: token
    }));
    const content = getApproveAmendmentContent({
      amendmentApproveResult,
      vendorName
    });
    setLoading(false);
    setApproveResultContent(content);
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "approve-amendment-action-page",
    children: /*#__PURE__*/_jsx(NotificationActionLayout, {
      state: loading ? {
        type: NotificationActionLayoutType.Loading
      } : approveResultContent ? {
        type: NotificationActionLayoutType.AfterAction,
        afterAction: approveResultContent
      } : {
        type: NotificationActionLayoutType.BeforeAction,
        beforeAction: {
          header: "Click the button below to approve the amendments to your agreement with ".concat(vendorName),
          buttonText: 'Approve amendments',
          onClick: sendApproveAmendmentsAction
        }
      }
    })
  });
};
export default ApproveAmendmentAction;